import { RootState } from '../../../../redux/store';

// still deciding if this is how we want to handle chat ui state for a selected chat session
export const selectChatUiBySessionId = (state: RootState) => state.chatUi.bySessionId;
